"use strict";
import classNames from "classnames";
import PureRenderMixin from "react-addons-pure-render-mixin";
import Caman from "../../util/caman";
import AnnotationCanvas from "../annotation/annotation_canvas";
import Api from "../../api/api";
import pageHelper from "../../helpers/document_pages";
import PageTextHighlighter from "./page_text_highlighter";
const showRawImage = (props) => props.annotating || props.justSaved;
const ZoomableImage = React.createClass({
  mixins: [PureRenderMixin],
  propTypes: {
    annotations: React.PropTypes.object,
    disableAnnotations: React.PropTypes.bool,
    page: React.PropTypes.object.isRequired,
    browserExpanded: React.PropTypes.bool,
    zoomLevel: React.PropTypes.number.isRequired,
    dragAndDropEnabled: React.PropTypes.bool,
    textToHighlight: React.PropTypes.node,
    annotating: React.PropTypes.bool.isRequired,
    cropping: React.PropTypes.bool.isRequired,
    justSaved: React.PropTypes.bool,
    annotationStampUrl: React.PropTypes.string,
    toneAdjustments: React.PropTypes.object,
    editedTextAnnotation: React.PropTypes.object
  },
  // LIFECYCLE
  getInitialState() {
    return {};
  },
  componentDidMount() {
    this.enableDragScroll();
    this.updateSizing();
    if (!this.props.disableAnnotations) {
      this.applyInitialAdjustments();
    }
  },
  componentWillUnmount() {
    this.disableDragScroll();
  },
  componentDidUpdate(prevProps) {
    this.updateSizing();
    if (!this.props.disableAnnotations) {
      this.updateAdjustments(prevProps);
    }
  },
  componentWillReceiveProps(newProps) {
    if (this.props.page.id !== newProps.page.id || this.props.browserExpanded !== newProps.browserExpanded) {
      this.updateSizing();
    }
  },
  // STATE
  updateSizing() {
    if (_.isEmpty(this.props.page)) {
      return;
    }
    const container = ReactDOM.findDOMNode(this.refs.container);
    const containerWidth = $(container).innerWidth();
    const sourceHeight = this.props.page.attachment_height;
    const sourceWidth = this.props.page.attachment_width;
    if (!sourceHeight || !sourceWidth) {
      throw new TypeError(`page ${this.props.page} with id ${this.props.page.id}
             is missing either width or height`);
    }
    const calculatedHeight = Math.round(
      containerWidth / sourceWidth * sourceHeight
    );
    if (this.props.zoomLevel === 1 && calculatedHeight !== this.state.imageHeight) {
      this.setState({
        imageHeight: calculatedHeight,
        imageWidth: containerWidth
      });
    }
  },
  applyInitialAdjustments() {
    const settings = this.props.account || Api.Account.currentSettings();
    if (!settings.tone_adjustments_enabled) {
      return;
    }
    const component = this;
    Caman(
      `#adjustment-canvas-${component.props.page.id}`,
      component.imageUrl(true),
      function() {
        const adjustments = component.props.toneAdjustments;
        this.reset();
        if (adjustments) {
          if (adjustments.sharpen) {
            this.sharpen(adjustments.sharpen);
          }
          if (adjustments.contrast) {
            this.contrast(adjustments.contrast / 1);
          }
          if (adjustments.brightness) {
            this.brightness(adjustments.brightness / 1);
          }
          if (adjustments.despeckle) {
            this.stackBlur(adjustments.despeckle / 100);
          }
        }
        this.render();
      }
    );
  },
  updateAdjustments(prevProps) {
    const settings = this.props.account || Api.Account.currentSettings();
    if (!settings.tone_adjustments_enabled) {
      return;
    }
    const component = this;
    if (prevProps.toneAdjustments === this.props.toneAdjustments && prevProps.page === this.props.page || !this.props.annotating && !this.props.justSaved) {
      return;
    }
    if (this.adjustmentTimeout) {
      clearTimeout(this.adjustmentTimeout);
    }
    this.adjustmentTimeout = setTimeout(
      () => {
        Caman(
          `#adjustment-canvas-${component.props.page.id}`,
          component.imageUrl(true),
          function() {
            this.reset();
            const adjustments = component.props.toneAdjustments;
            if (adjustments) {
              if (adjustments.sharpen) {
                this.sharpen(adjustments.sharpen);
              }
              if (adjustments.contrast) {
                this.contrast(adjustments.contrast / 1);
              }
              if (adjustments.brightness) {
                this.brightness(adjustments.brightness / 1);
              }
              if (adjustments.despeckle) {
                this.stackBlur(adjustments.despeckle / 1);
              }
            }
            this.render();
          }
        );
      },
      200
    );
  },
  adjustmentTimeout: null,
  borderSize: 4,
  // RENDER
  imageUrl(forceRaw) {
    return pageHelper.url(
      this.props.page,
      forceRaw || showRawImage(this.props)
    );
  },
  render() {
    const text = this.props.dragAndDropEnabled ? this.pageTextHighlighter() : null;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "document-browser__zoomable-container",
        ref: "container"
      },
      this.annotations(this.props.disableAnnotations),
      text,
      this.adjustmentCanvas(this.props.disableAnnotations),
      this.image(this.props)
    );
  },
  image(props) {
    const classes = classNames({
      "document-browser__zoomable-container": true,
      "document-browser__zoomable-container--zoomed": this.isZoomed()
    });
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        ref: "image",
        width: this.imageSize().width,
        height: this.imageSize().height,
        className: classes,
        style: this.calculateStyle(),
        src: this.imageUrl(),
        crossOrigin: "anonymous"
      }
    );
  },
  adjustmentCanvas(disableAnnotations) {
    if (disableAnnotations) {
      return;
    }
    const settings = this.props.account || Api.Account.currentSettings();
    if (!settings.tone_adjustments_enabled) {
      return;
    }
    const width = this.imageSize().width || 0;
    const height = this.imageSize().height || 0;
    const style = {
      width,
      height,
      position: "absolute",
      zIndex: this.props.annotating ? 998 : 0,
      top: 0,
      left: 0
    };
    return /* @__PURE__ */ React.createElement(
      "canvas",
      {
        style,
        id: `adjustment-canvas-${this.props.page.id}`,
        "data-caman-id": this.props.page.id,
        ref: "adjustmentCanvas"
      }
    );
  },
  annotations(disableAnnotations) {
    if (disableAnnotations || !this.props.annotating && !this.props.justSaved) {
      return;
    }
    const settings = this.props.account || Api.Account.currentSettings();
    if (settings.document_annotation_enabled && this.state.imageWidth && this.state.imageHeight) {
      const width = this.imageSize().width;
      const height = this.imageSize().height;
      const style = {
        width,
        height,
        position: "absolute",
        zIndex: this.props.annotating ? 999 : 9,
        top: 0,
        left: 0
      };
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "document-browser__zoomable-container__annotations",
          style
        },
        /* @__PURE__ */ React.createElement(
          AnnotationCanvas,
          {
            width,
            height,
            page: this.props.page,
            annotating: this.props.annotating,
            cropping: this.props.cropping,
            annotationStampUrl: this.props.annotationStampUrl
          }
        )
      );
    }
  },
  imageSize: function imageSize() {
    return {
      width: this.props.zoomLevel * this.state.imageWidth,
      height: this.props.zoomLevel * this.state.imageHeight
    };
  },
  pageTextHighlighter() {
    return /* @__PURE__ */ React.createElement(
      PageTextHighlighter,
      {
        lines: this.props.page.lines,
        imageHeight: this.state.imageHeight,
        imageWidth: this.state.imageWidth,
        textToHighlight: this.props.textToHighlight
      }
    );
  },
  calculateStyle() {
    if (this.state.imageHeight) {
      const width = this.imageSize().width || 0;
      const height = this.imageSize().height || 0;
      return {
        maxWidth: 1e4,
        maxHeight: 1e4,
        width: `${width}px`,
        height: `${height}px`
      };
    }
    return {
      height: "auto",
      width: "auto",
      maxWidth: "100%",
      maxHeight: "none"
    };
  },
  isZoomed() {
    return this.props.zoomLevel > 1;
  },
  container() {
    return $(ReactDOM.findDOMNode(this.refs.container));
  },
  enableDragScroll() {
    const ref = this.refs.image || this.refs.adjustmentCanvas;
    const el = ReactDOM.findDOMNode(ref);
    let lastClientX;
    let lastClientY;
    let pushed;
    const scroller = ReactDOM.findDOMNode(this.refs.container);
    el.md = function(e) {
      pushed = 1;
      lastClientX = e.clientX;
      lastClientY = e.clientY;
      e.preventDefault();
      e.stopPropagation();
    };
    el.mu = function() {
      pushed = 0;
    };
    el.mm = function(e) {
      if (pushed) {
        scroller.scrollLeft -= -lastClientX + (lastClientX = e.clientX);
        scroller.scrollTop -= -lastClientY + (lastClientY = e.clientY);
      }
    };
    el.rs = function(scaleFactor) {
      el.mm({
        clientX: lastClientX * scaleFactor,
        clientY: lastClientY * scaleFactor
      });
    };
    el.addEventListener("mousedown", el.md, true);
    window.addEventListener("mouseup", el.mu, 0);
    window.addEventListener("mousemove", el.mm, 0);
  },
  disableDragScroll() {
    const el = ReactDOM.findDOMNode(this.refs.image);
    el.removeEventListener("mousedown", el.md);
    window.removeEventListener("mouseup", el.mu);
    window.removeEventListener("mousemove", el.mm);
  }
});
export default ZoomableImage;
